/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ReRateServiceCompleteResponse,
  ReRateServiceGetResponse,
  ReRateServiceRaiseResponse,
} from '../models/index';
import {
    ReRateServiceCompleteResponseFromJSON,
    ReRateServiceCompleteResponseToJSON,
    ReRateServiceGetResponseFromJSON,
    ReRateServiceGetResponseToJSON,
    ReRateServiceRaiseResponseFromJSON,
    ReRateServiceRaiseResponseToJSON,
} from '../models/index';

export interface ReRatesApiApiReRatesCompletePostRequest {
    timePeriodDate?: Date;
    policyNumber?: string;
    employeeMedicalEmployee?: number;
    employeeMedicalSpouse?: number;
    employeeMedicalChild?: number;
    employeeMedicalFamily?: number;
    currentPremiumEQ?: number;
    newPremiumEQ?: number;
    estimatedStandardNBRate?: number;
    reissueType?: string;
    override?: number;
    optionsShutoff?: boolean;
    increase?: number;
    note?: string;
    file?: Blob;
}

export interface ReRatesApiApiReRatesGetGetRequest {
    timePeriodDate?: Date;
    policyNumber?: string;
}

export interface ReRatesApiApiReRatesRaisePostRequest {
    timePeriodDate?: Date;
    policyNumber?: string;
    note?: string;
    file?: Blob;
}

/**
 * 
 */
export class ReRatesApi extends runtime.BaseAPI {

    /**
     */
    async apiReRatesCompletePostRaw(requestParameters: ReRatesApiApiReRatesCompletePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReRateServiceCompleteResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }

        if (requestParameters['policyNumber'] != null) {
            formParams.append('PolicyNumber', requestParameters['policyNumber'] as any);
        }

        if (requestParameters['employeeMedicalEmployee'] != null) {
            formParams.append('EmployeeMedicalEmployee', requestParameters['employeeMedicalEmployee'] as any);
        }

        if (requestParameters['employeeMedicalSpouse'] != null) {
            formParams.append('EmployeeMedicalSpouse', requestParameters['employeeMedicalSpouse'] as any);
        }

        if (requestParameters['employeeMedicalChild'] != null) {
            formParams.append('EmployeeMedicalChild', requestParameters['employeeMedicalChild'] as any);
        }

        if (requestParameters['employeeMedicalFamily'] != null) {
            formParams.append('EmployeeMedicalFamily', requestParameters['employeeMedicalFamily'] as any);
        }

        if (requestParameters['currentPremiumEQ'] != null) {
            formParams.append('CurrentPremiumEQ', requestParameters['currentPremiumEQ'] as any);
        }

        if (requestParameters['newPremiumEQ'] != null) {
            formParams.append('NewPremiumEQ', requestParameters['newPremiumEQ'] as any);
        }

        if (requestParameters['estimatedStandardNBRate'] != null) {
            formParams.append('EstimatedStandardNBRate', requestParameters['estimatedStandardNBRate'] as any);
        }

        if (requestParameters['reissueType'] != null) {
            formParams.append('ReissueType', requestParameters['reissueType'] as any);
        }

        if (requestParameters['override'] != null) {
            formParams.append('Override', requestParameters['override'] as any);
        }

        if (requestParameters['optionsShutoff'] != null) {
            formParams.append('OptionsShutoff', requestParameters['optionsShutoff'] as any);
        }

        if (requestParameters['increase'] != null) {
            formParams.append('Increase', requestParameters['increase'] as any);
        }

        if (requestParameters['note'] != null) {
            formParams.append('Note', requestParameters['note'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }


        let urlPath = `/api/ReRates/Complete`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReRateServiceCompleteResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiReRatesCompletePost(requestParameters: ReRatesApiApiReRatesCompletePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReRateServiceCompleteResponse> {
        const response = await this.apiReRatesCompletePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiReRatesGetGetRaw(requestParameters: ReRatesApiApiReRatesGetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReRateServiceGetResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timePeriodDate'] != null) {
            queryParameters['TimePeriodDate'] = (requestParameters['timePeriodDate'] as any).toISOString();
        }

        if (requestParameters['policyNumber'] != null) {
            queryParameters['PolicyNumber'] = requestParameters['policyNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/ReRates/Get`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReRateServiceGetResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiReRatesGetGet(requestParameters: ReRatesApiApiReRatesGetGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReRateServiceGetResponse> {
        const response = await this.apiReRatesGetGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiReRatesRaisePostRaw(requestParameters: ReRatesApiApiReRatesRaisePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReRateServiceRaiseResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }

        if (requestParameters['policyNumber'] != null) {
            formParams.append('PolicyNumber', requestParameters['policyNumber'] as any);
        }

        if (requestParameters['note'] != null) {
            formParams.append('Note', requestParameters['note'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }


        let urlPath = `/api/ReRates/Raise`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReRateServiceRaiseResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiReRatesRaisePost(requestParameters: ReRatesApiApiReRatesRaisePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReRateServiceRaiseResponse> {
        const response = await this.apiReRatesRaisePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
